import { createSlice } from "@reduxjs/toolkit";

export const orgsSlice = createSlice({
  name: "orgs",
  initialState: {
    value: false,
  },
  reducers: {
    add: (state, sel) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = sel;
    }
  },
});

// Action creators are generated for each case reducer function
export const { add } = orgsSlice.actions;

export default orgsSlice.reducer;
